import { createFormAction } from 'redux-form-saga';
import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_CURRENT_MONTH_FUNNELS = createRequestTypes('GET_CURRENT_MONTH_FUNNELS');
export const getCurrentMonthFunnels = {
  request: data => action(GET_CURRENT_MONTH_FUNNELS[REQUEST], data),
  success: data => action(GET_CURRENT_MONTH_FUNNELS[SUCCESS], { data }),
  failure: error => action(GET_CURRENT_MONTH_FUNNELS[FAILURE], { error }),
};

export const GET_LAST_MONTH_FUNNELS = createRequestTypes('GET_LAST_MONTH_FUNNELS');
export const getLastMonthFunnels = {
  request: data => action(GET_LAST_MONTH_FUNNELS[REQUEST], data),
  success: data => action(GET_LAST_MONTH_FUNNELS[SUCCESS], { data }),
  failure: error => action(GET_LAST_MONTH_FUNNELS[FAILURE], { error }),
};

export const GET_FIRST_MONTH_TO_COMPARE = createRequestTypes('GET_FIRST_MONTH_TO_COMPARE');
export const getFirstMonthToCompare = {
  request: data => action(GET_FIRST_MONTH_TO_COMPARE[REQUEST], data),
  success: data => action(GET_FIRST_MONTH_TO_COMPARE[SUCCESS], { data }),
  failure: error => action(GET_FIRST_MONTH_TO_COMPARE[FAILURE], { error }),
};

export const GET_SECOND_MONTH_TO_COMPARE = createRequestTypes('GET_SECOND_MONTH_TO_COMPARE');
export const getSecondMonthToCompare = {
  request: data => action(GET_SECOND_MONTH_TO_COMPARE[REQUEST], data),
  success: data => action(GET_SECOND_MONTH_TO_COMPARE[SUCCESS], { data }),
  failure: error => action(GET_SECOND_MONTH_TO_COMPARE[FAILURE], { error }),
};

export const GET_TARGET = createRequestTypes('GET_TARGET');
export const getTarget = {
  request: data => action(GET_TARGET[REQUEST], data),
  success: data => action(GET_TARGET[SUCCESS], { data }),
  failure: error => action(GET_TARGET[FAILURE], { error }),
};

export const putTarget = createFormAction('PUT_TARGET');

export const GET_USERS_HISTORY = createRequestTypes('GET_USERS_HISTORY');
export const getUsersHistory = {
  request: data => action(GET_USERS_HISTORY[REQUEST], data),
  success: data => action(GET_USERS_HISTORY[SUCCESS], { data }),
  failure: error => action(GET_USERS_HISTORY[FAILURE], { error }),
};

export const GET_TOTALS = createRequestTypes('GET_TOTALS');
export const getTotals = {
  request: data => action(GET_TOTALS[REQUEST], data),
  success: data => action(GET_TOTALS[SUCCESS], { data }),
  failure: error => action(GET_TOTALS[FAILURE], { error }),
};

export const RESET_DASHBOARD_LOADED_FLAGS = 'RESET_DASHBOARD_LOADED_FLAGS';
export const resetDahboardLoadedFlags = () => action(RESET_DASHBOARD_LOADED_FLAGS);

export const RESET_DASHBOARD_FIRST_AND_SECOND_MONTHS_FUNNELS = 'RESET_DASHBOARD_FIRST_AND_SECOND_MONTHS_FUNNELS';
export const resetDashboardFirstAndSecondMonthFunnels = () => action(RESET_DASHBOARD_FIRST_AND_SECOND_MONTHS_FUNNELS);

export const GET_BACKOFFICE_HISTORY = createRequestTypes('GET_BACKOFFICE_HISTORY');
export const getBackofficeHistory = {
  request: search => action(GET_BACKOFFICE_HISTORY[REQUEST], search),
  success: data => action(GET_BACKOFFICE_HISTORY[SUCCESS], { data }),
  failure: error => action(GET_BACKOFFICE_HISTORY[FAILURE], { error }),
};
